module.exports = __webpack_public_path__ + "static/media/ustav_iq.46e83daa.pdf";